module.exports = __webpack_public_path__ + "img/cas-bg.ae09def4.png";